var React = require('react');

function SlickNext (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Path_687","data-name":"Path 687","d":"M-24430-19197.334v12h12","transform":"translate(-3691.568 -30831.504) rotate(-135)","fill":"none","stroke":"#000","strokeWidth":"2"}));
}

SlickNext.defaultProps = {"width":"24","height":"19","viewBox":"0 0 24 19"};

module.exports = SlickNext;

SlickNext.default = SlickNext;
